var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoricalInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 345,
    width: 24,
    height: 25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 346,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 346,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 346,
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-528 -345)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.898 349.15C549.065 349.15 549.217 349.219 549.325 349.329 549.348 349.352 549.37 349.378 549.39 349.405L549.439 349.489C549.486 349.585 549.505 349.687 549.499 349.786L549.497 361.923C549.497 362.163 549.357 362.369 549.155 362.465L540.311 366.766C540.243 366.806 540.167 366.833 540.088 366.844 540.076 366.845 540.065 366.847 540.053 366.848 540.036 366.85 540.018 366.85 540 366.85L539.946 366.848C539.935 366.847 539.924 366.845 539.913 366.844 539.833 366.833 539.757 366.806 539.689 366.766L530.845 362.465C530.643 362.369 530.503 362.163 530.503 361.923L530.501 349.786C530.495 349.687 530.514 349.586 530.56 349.49L530.561 349.489C530.591 349.428 530.63 349.374 530.675 349.328 530.783 349.219 530.935 349.15 531.102 349.15 531.217 349.15 531.324 349.182 531.415 349.238L540 353.413 548.585 349.238C548.676 349.182 548.783 349.15 548.898 349.15ZM548.298 350.708 540.596 354.454 540.596 365.295 548.298 361.549 548.298 350.708ZM531.701 350.708 531.701 361.549 539.396 365.291 539.396 354.45 531.701 350.708ZM544.446 349.489C544.446 349.489 544.446 349.49 544.446 349.49 544.576 349.757 544.489 350.073 544.254 350.238L544.171 350.288 540.264 352.187C540.219 352.209 540.172 352.225 540.126 352.235 540.115 352.236 540.105 352.238 540.094 352.24 540.078 352.243 540.06 352.245 540.044 352.246L540.022 352.247 540.001 352.248C539.986 352.248 539.971 352.247 539.956 352.246 539.94 352.245 539.922 352.243 539.905 352.241 539.895 352.238 539.885 352.236 539.874 352.234 539.828 352.225 539.781 352.209 539.736 352.187L535.829 350.288C535.533 350.144 535.41 349.787 535.554 349.49 535.554 349.49 535.554 349.489 535.554 349.489 535.7 349.192 536.058 349.069 536.355 349.213L540 350.985 543.645 349.213C543.942 349.069 544.3 349.192 544.446 349.489Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricalInsights);
export default __webpack_public_path__ + "static/media/historical_insights.3384db780b006759f056413341567d42.svg";
export { ForwardRef as ReactComponent };